import React, { ReactChild, FC } from 'react'

import './RadioButton.scss'

type RadioButtonProps = {
  id: string
  label: ReactChild
  name: string
  isErroneous?: boolean
} & JSX.IntrinsicElements['input']

const RadioButton: FC<RadioButtonProps> = (props) => {
  const errorClassName = props.isErroneous ? 'error' : ''

  return (
    <div className={'radio-container'}>
      <input type='radio' className={'input-radio'} ref={props.ref} {...props} />
      <label className={`label-radio ${errorClassName}`} htmlFor={props.id}>
        {props.label}
      </label>
    </div>
  )
}

RadioButton.defaultProps = {
  defaultChecked: false,
}

export { RadioButton }
